import { ChartDatum } from './ChartDatum';

export type BarDatum = {
  id: string;
  value: number;
};

export const createBarDatumFromChartDatum = (datum: ChartDatum): BarDatum[] => {
  return datum.data.reduce((result: BarDatum[], d) => {
    if (d.x instanceof Date) return result;
    if (d.y instanceof Date || typeof d.y === 'string') return result;

    const datum: BarDatum = {
      id: d.x.toString(),
      value: d.y,
    };
    return [...result, datum];
  }, []);
};
